import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

const tileGridTilesPerRowVar = '--tile-grid-tiles-per-row';
export const tileGridDesktopTilesPerRowVar =
  '--tile-grid-desktop-tiles-per-row';

export const TileGridHolder = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
`;

export const TileGridTileHolder = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  max-width: 400px;

  ${tileGridTilesPerRowVar}: 1;

  width: calc(100% / var(${tileGridTilesPerRowVar}));

  @media all and (min-width: ${cssBreakpoints.xsUp}) {
    ${tileGridTilesPerRowVar}: 2;
  }

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    ${tileGridTilesPerRowVar}: 2;
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    ${tileGridTilesPerRowVar}: var(${tileGridDesktopTilesPerRowVar});
  }
`;
